import React, { useState } from "react";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import MainInput from "../Elements/MainInput/MainInput";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";
import { createRole } from "../../services/RoleService";
import "./AdminModalForm.css";

const AdminCreateRoleModal = ({ isOpen, onClose, onCreated }) => {
  const [formData, setFormData] = useState({
    name: "",
    rate: "",
    cutoff: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? (value === "" ? "" : Number(value)) : value,
    }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      setSaving(true);

      const payload = {
        name: formData.name.trim(),
        rate: Number(formData.rate),
        cutoff: Number(formData.cutoff),
      };

      await createRole(payload);

      setSuccess("Role created successfully.");
      setTimeout(() => {
        onCreated?.();
        onClose();
      }, 1000);
    } catch (err) {
      setError(err.message || "Failed to create role");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={saving ? () => {} : onClose}
      title="Create Role"
      actions={
        <>
          <SecondButton onClick={onClose} disabled={saving}>
            Cancel
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={saving}>
            {saving ? "Creating..." : "Create Role"}
          </MainButton>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="admin-modal-form">
        <label>
          Name *
          <MainInput
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={saving}
            placeholder="Role name"
          />
        </label>

        <label>
          Rate *
          <MainInput
            type="number"
            name="rate"
            value={formData.rate}
            onChange={handleChange}
            required
            disabled={saving}
            placeholder="0"
          />
        </label>

        <label>
          Cutoff *
          <MainInput
            type="number"
            name="cutoff"
            value={formData.cutoff}
            onChange={handleChange}
            required
            disabled={saving}
            placeholder="0"
          />
        </label>

        {error && (
          <div className="admin-modal-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {success && (
          <div className="admin-modal-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </form>
    </Modal>
  );
};

export default AdminCreateRoleModal;
